import { render } from "./ReportePorTipoActivo.vue?vue&type=template&id=46bd7042&scoped=true"
import script from "./ReportePorTipoActivo.vue?vue&type=script&lang=js"
export * from "./ReportePorTipoActivo.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./ReportePorTipoActivo.vue?vue&type=style&index=1&id=46bd7042&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46bd7042"]])

export default __exports__